<template>
    <div class="post-index-container">
        <div class="block-title-container">
            <h2 class="title" v-if="title" v-html="title">Articles</h2>
            <div class="filter-container">
                <div class="select-wrap" ref="productWrap" :class="{visible: productCategories.length>0}">
                    <select class="products" v-model="selectedProductCategory" @change="filterChanged()">
                        <option name="product" value="">All Products</option>
                        <option v-for="(product, index) in productCategories" :key="index" name="product" :value="product.term_id" v-html="product.name"></option>
                    </select>
                </div>
                <div class="select-wrap" ref="marketWrap" :class="{visible: markets.length > 0}">
                    <select class="markets" v-model="selectedMarket" @change="filterChanged()">
                        <option name="market" value="">All Markets</option>
                        <option v-for="(market, index) in markets" :key="index" :name="market" :value="market.term_id" v-html="market.name"></option>
                    </select>
                </div>
            </div>
        </div>
        <div class="posts-container bg-white-with-lines">
            <div class="item-collection-list posts" v-if="posts.length > 0">
                <div class="item" v-for="(item, index) in topPosts" :key="index">
                    <div class="image-container">
                        <img :src="getItemImage(item)">
                    </div>
                    <div class="content-container">
                        <div class="top-title" v-html="getItemDate(item)"></div>
                        <h2 class="title" v-html="item.post_title"></h2>
                        <div class="description" v-html="item.acf_fields.feature_settings.post_excerpt"></div>
                        <div class="button-container">
                            <a class="hover-button orange" :href="item.permalink">Continue reading</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item-collection-grid">
                <div class="item post" v-for="(item, index) in bottomPosts" :key="index" ref="gridItem" @mouseleave="removeHover(index)">
                    <div class="top-title" v-html="getItemDate(item)"></div>
                    <h2 class="title" v-html="item.post_title"></h2>
                    <div class="description-short" v-html="item.acf_fields.feature_settings.post_excerpt"></div>
                    <div class="toggle-container hover-remove">
                        <i class="fas fa-plus tx-orange plus hover-toggle" @mouseenter="addHover(index)"></i>
                    </div>
                    <div class="hover-details">
                        <div class="description" v-html="item.acf_fields.feature_settings.post_excerpt"></div>
                        <div class="button-container">
                            <a class="hover-button orange" :href="item.permalink">Continue reading</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="no-items" ref="emptyList" style="display: none;">
                <h3 class="roboto-mono message">No articles found that match this filter.</h3>
            </div>
            <div class="ajax-spinner" v-if="isLoading">
                <i class="fas fa-spinner fa-spin float-right tx-dark-gray"></i>
            </div>
            <div class="load-more-container" v-if="isShowLoadMore">
                <a class="btn tx-dark-gray float-right" href="javascript:void(0);" @click="loadPosts()">Load more <i class="fas fa-chevron-down"></i></a>
            </div>
        </div>
    </div>
</template>

<script>
import postApi from '../../post-api';
import listFilterApi from '../../list-filter-api';

export default {
    props: {
        title: {
            type: String
        }
    },
    data() {
        return {
            posts: [],
            markets: [],
            productCategories: [],
            page: 1,
            isLoading: false,
            isShowLoadMore: false,
            selectedProductCategory: "",
            selectedMarket: ""
        }
    },
    mounted() {
        this.loadFilters();
        this.loadPosts();
    },
    computed: {
        topPosts : function() {
            return this.posts.slice(0, 4);
        },
        bottomPosts: function() {
            return this.posts.slice(4);
        }
    },
    methods: {
        loadPosts() {
            this.isLoading = true;
            this.isShowLoadMore = false;
            this.$refs.emptyList.style.display = "none";
            
            postApi.loadPosts({'selection_type': 'all', 'max_items': 8}, this.selectedProductCategory, this.selectedMarket, this.page)
                .then(response => {
                    if (typeof(response) != 'undefined') {
                        let data = response.data.payload;
                        if (typeof(data.items) != 'undefined') {
                            this.posts = this.posts.concat(data.items);
                            this.isShowLoadMore = data.has_more;
                            this.page++;

                            if (this.posts.length == 0) {
                                this.$refs.emptyList.style.display = "block";
                            } else {
                                this.$refs.emptyList.style.display = "none";
                            }
                        }
                    } else {
                        this.isShowLoadMore = true;
                    }
                    this.isLoading = false;
                })
        },
        loadFilters: function() {
            listFilterApi.getFilters('post')
                .then(response => {
                    if (typeof(response) != 'undefined') {
                        let data = response.data.payload;
                        this.markets = data.markets;
                        this.productCategories = data.productCategories;
                    }
                })
        },
        filterChanged: function() {
            // Clear items
            this.posts = [];
            // Reset page
            this.page = 1;

            this.loadPosts();
        },
        getItemImage(item) {
            let image = item.acf_fields.feature_settings.primary_image;
            if(image){
                return image.url;
            } else {
                return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOkAAAE2CAMAAACz9kWfAAAAeFBMVEUkLzj////0sSHZ2twiLjjb3N70siLW2Nq+wcQmMDpRWGD4+fhqcHjh4+SJj5VOSDPPmiaanqNlWDGUdCxORyu2iih0fIJ4foRob3YzNzRFQjB6gIZ6ZS3k5ujS1djBw8bAwsVnbnVQWGBJUlo8Rk5rWjC3iyq2iyiLJzTBAAABIklEQVR42uzWWVLCQBRA0UZCY0RwFhJwnva/Q2PCh1YBn1bx+pwd3HqvhwQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/Jf39VVv8ZaCez0d9SbnKbizbelUaRgFlq5ScL9nWnVSWKG3t6pKKe1jd5/TyOsbfKb16mmyNZ8NpbOH8WQwXac46uV8tNdskeKo75UqPVYFlR6+kQI9qvXL83ivx2XiCB3Yz0Cr+6elatrbXtuk4C7uTn7ky+sUXFeac5daRGknDzMNdER3l+aci5lpEdv7mbuZFnEjfeVhph8ptrrZ3PQ2bQquDvk5AgAAAAAAAAAAAAAAAAAAAAAAAADguz04IAEAAAAQ9P91OwIVAAAAAAAAAAAAAGArV1ELg7GvX10AAAAASUVORK5CYII=";
            }
        },
        getItemDate(item) {
            var options = { year: 'numeric', month: 'long', day: 'numeric' };
            let date = new Date(item.post_date);
            return date.toLocaleDateString("en-US", options);
        },
        addHover(index) {
            this.$refs.gridItem[index].classList.add('hover');
        },
        removeHover(index) {
            this.$refs.gridItem[index].classList.remove('hover');
        }
    }
}
</script>